import type { ReactElement, CSSProperties } from "react";
import styled from "styled-components";
import { Typography, } from "@bracket/ui/components";

export declare type ChevronDirectionProps = {
	className?: string;
	style?: CSSProperties;
	direction: "up" | "down" | "left" | "right";
	color?: string;
	size?: number; // percentage of container size (e.g., 50 = 50%)
	label?: string;
	hideChevron?: boolean;
}

export const ChevronDirection = ({
	direction,
	color,
	size = 100, // default to 100% of container
	label,
	hideChevron = false,
}: ChevronDirectionProps): ReactElement => {
	const getRotation = () => {
		switch (direction) {
			case "up":
				return "rotate(180deg)";
			case "down":
				return "rotate(0deg)";
			case "left":
				return "rotate(90deg)";
			case "right":
				return "rotate(270deg)";
			default:
				return "rotate(0deg)";
		}
	};

	return (
		<Brace transform={getRotation()} width={size} height={size}>
			<Label>
				<Typography variant="paragraphXSM">{label}</Typography>
			</Label>
			<Icon transform={getRotation()} width={size} height={size}>
				{!hideChevron && <svg viewBox="0 0 16 10" xmlns="http://www.w3.org/2000/svg" style={{ width: "100%", height: "100%" }}>
					<title>Chevron pointing {direction}</title>
					<path 
						d="M13.6963 9.04401L8.47667 3.82443L3.25709 9.04401C2.73244 9.56866 1.88493 9.56866 1.36028 9.04401C0.835635 8.51936 0.835635 7.67186 1.36028 7.14721L7.535 0.972495C8.05964 0.447846 8.90715 0.447846 9.4318 0.972495L15.6065 7.14721C16.1312 7.67185 16.1312 8.51936 15.6065 9.04401C15.0819 9.55521 14.2209 9.56866 13.6963 9.04401Z" 
						fill={color}
					/>
				</svg>}
			</Icon>
		</Brace>
	);
};

const Brace = styled.div<{ transform: string; width: number; height: number; $label?: boolean;}>`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	gap: 0.5rem;

`;

const Icon = styled.div<{ transform: string; width: number; height: number; }>`
	display: flex;
	align-items: center;
	justify-content: center;
	transform: ${({ transform, }) => transform};
	width: ${({ width,}) => `${width}%`};
	height: ${({ height, }) => `${height}%`};
`;

const Label = styled.div<{ color?: string; }>`
	width: 100%;
	height: 100%;
	color: ${({ color, }) => color || "inherit" };
`;
